import { Topic, Post } from '../../types/forum';
import { getUserById } from '../users';

export const categoryId = '1';
export const categoryName = 'New? Start here to learn more about Goosifer!';
export const categoryDescription = 'General information about Goosifer, the Sloan\'s Lake monster. This is a good place to start to learn more about the curious creature!';

export const topics: Topic[] = [
  {
    id: '1',
    title: 'What is Goosifer?',
    description: 'Essential information about the Sloan\'s Lake Monster',
    categoryId: '1',
    authorId: '1',
    author: getUserById('1')!,
    createdAt: '2019-03-15T10:30:00Z',
    lastPostAt: '2024-12-15T14:22:00Z',
    postCount: 1,
    viewCount: 1247,
    isSticky: true
  }
];

export const posts: Post[] = [
  {
    id: '1',
    topicId: '1',
    authorId: '1',
    author: getUserById('1')!,
    content: `<h2>Description</h2>

<p>Goosifer, also known as "the Sloan's Lake Monster" or "the Colfax Creature" in Coloradoan folklore, is a hybrid creature purported to have the head of a goose and a body similar to a <a href="https://en.wikipedia.org/wiki/Bigfoot" target="_blank">Bigfoot/Sasquatch</a>. Evidence of its existence is based on a growing number of anecdotal visual <a href="/category/2">sightings</a> but there has yet to be video or audio recordings. Folklorists are just now starting to document their findings about this previously unknown creature.</p>

<p>Not many people have seen the creature, but it has been described as a large, muscular, goose with an ape/Bigfoot like body ranging 2-3 meters in height, covered in black, brown, and tan fur with feathers akin to a <a href="https://en.wikipedia.org/wiki/Canada_goose" target="_blank">Canada goose</a>.</p>

<h2>Image</h2>

<p><img src="/images/goosiferdrawing1.jpg" alt="Sketch from one of the first sightings of the creature" /></p>
<p><em>Sketch from one of the first sightings of the creature <a href="/topic/3">documented here</a></em></p>

<h2>History</h2>

<h3>Origin of the Names</h3>
<ul>
<li>The legends and rumors about such a creature existed before there was a single name for it.</li>
<li>Goosifer has become the most common name given the size of the creature and its glowing red eyes, eerily similar to that of Denver International Airport's <a href="https://en.wikipedia.org/wiki/Blue_Mustang" target="_blank">Blue Mustang aka Blucifer</a> sculpture (that has a sorted history of its own!)</li>
<li>Sloan's Lake Monster because of recent and increased sightings in the Sloan's Lake neighborhood in Northwest Denver</li>
<li><a href="https://en.wikipedia.org/wiki/Colfax_Avenue" target="_blank">Colfax Creature</a> was first adopted because the creature has been sighted late at night in various locations along the lengthy and infamous Colfax Avenue</li>
</ul>

<h2>Sightings</h2>

<p>Nearly all claims of sightings are located around Sloan's Lake and the Western corridor of Colfax Avenue.</p>
<p><a href="/category/2">Sightings and Tracking Forum</a> has more details.</p>

<h2>Annual Search Party</h2>

<p>Each year, in early Autumn, a group of curious citizens gather for an organized search around Sloan's Lake. A search party is conducted over the course of 10 hours as citizens circle the lake 10 times (totally 26.2ish miles!), starting at the beginning of every hour in hopes that they will get a sighting or an opportunity to catch the creature in action!</p>
<p><a href="/category/3">The Annual Search Party Forum</a> has more details about this event.</p>`,
    timestamp: '2019-03-15T10:30:00Z'
  }
]; 